<div class="lum-c-app-integration-account-bulk-create-products-modal">
  <div
    *ngIf="loading || submitting"
    class="lum-c-app-integration-account-bulk-create-products-modal__overlay"
    lumAppLoader
    [loading]="true"
    [classes]="'loading'"
    aria-live="polite"
    role="status"
  >
    <span class="sr-only">Loading, please wait...</span>
  </div>

  <h2 mat-dialog-title id="dialog-title">Create Unmapped Products in Bulk</h2>

  <mat-dialog-content aria-labelledby="dialog-title">
    <p class="mb-4">
      This will create Luminous products for unmapped products from your
      integration. Please provide default values for the new products.
    </p>

    <form [formGroup]="form">
      <div formGroupName="defaultValues">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Category</mat-label>
              <mat-select
                formControlName="category_id"
                (selectionChange)="onCategoryChange($event.value)"
              >
                <mat-option
                  *ngFor="let category of productCategoriesSvc.productCategories$"
                  [value]="category.id"
                >
                  {{ category.product_category }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('defaultValues.category_id').invalid">
                Category is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Subcategory</mat-label>
              <mat-select formControlName="subcategory_id">
                <ng-container
                  *ngFor="let subcategory of productSubCategoriesSvc.subCategories$"
                >
                  <mat-option
                    *ngIf="
                      !selectedCategory ||
                      subcategory.category_id == selectedCategory.id
                    "
                    [value]="subcategory.id"
                  >
                    {{ subcategory.sub_category }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('defaultValues.subcategory_id').invalid">
                Subcategory is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="submitting">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="form.invalid || submitting"
    >
      Create Products
    </button>
  </mat-dialog-actions>
</div>
